import Image, { ImageProps } from 'next/image'

import { useClass } from '@/hooks/useClass'

import { IconEdit } from '../../General'

const VARIANT_SIZE_MD = '68px'

const variantSizes = {
  md: {
    width: VARIANT_SIZE_MD,
    height: VARIANT_SIZE_MD,
  },
} as const

export type AvatarProps = {
  /**
   * 次のうちの一つ: 選択中 | ユーザー名 | 選択肢
   */
  alt: `${string}のアバター`
  src: string
  variantSize?: keyof typeof variantSizes
  selected?: boolean
  editProps?: {
    isEditable: boolean
    onClickEdit: () => void
  }
  wrapperClassName?: string
  imageProps?: Omit<ImageProps, 'src' | 'width' | 'height'>
}

export const Avatar = ({
  alt,
  src,
  variantSize = 'md',
  selected,
  editProps,
  wrapperClassName,
  imageProps,
}: AvatarProps) => {
  const wrapperClass = useClass('flex items-end relative', wrapperClassName)
  const imageWrapperClass = useClass(
    'absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 rounded-full w-[68px] h-[68px]',
    variantSize === 'md' ? `w-[68px] h-[68px]` : '',
    selected || editProps?.isEditable ? 'border-2 border-interactive-to' : ''
  )

  return (
    <div className={wrapperClass}>
      <div className="relative w-[56px] h-[56px] rounded-full">
        <Image
          src={src}
          alt={alt}
          className={imageProps?.className}
          {...variantSizes[variantSize]}
        />
        <div className={imageWrapperClass} />
        {!!editProps?.isEditable && (
          <button
            type="button"
            onClick={editProps?.onClickEdit}
            aria-label="アバターを編集する"
            className="absolute -right-[10px] -bottom-[10px]"
          >
            <IconEdit className="text-[32px]" />
          </button>
        )}
      </div>
    </div>
  )
}
